export const TARIFF_SUGGESTIONS = {
  cosmetic: [
    {
      id: 122,
      name: 'Замена повреждённой трубы',
      price: 5100,
      unit: 'PIECE',
    },
    {id: 752, name: 'Перенос розетки', price: 2400, unit: 'PIECE'},
    {
      id: 1270,
      name: 'Возведение перегородки из кирпича',
      price: 1400,
      unit: 'METER_SQUARED',
    },
    {
      id: 769,
      name: 'Выравнивание потолка',
      price: 1000,
      unit: 'METER_SQUARED',
    },
    {
      id: 192,
      name: 'Шпатлёвка потолка под покраску',
      price: 650,
      unit: 'METER_SQUARED',
    },
    {
      id: 825,
      name: 'Выравнивание стены',
      price: 800,
      unit: 'METER_SQUARED',
    },
    {
      id: 191,
      name: 'Шпатлёвка стен под покраску',
      price: 600,
      unit: 'METER_SQUARED',
    },
    {
      id: 634,
      name: 'Составление плана электропроводки',
      price: 600,
      unit: 'PIECE',
    },
    {
      id: 855,
      name: 'Монтаж тёплого пола (водяного)',
      price: 600,
      unit: 'METER_SQUARED',
    },
    {
      id: 5324,
      name: 'Составление плана сантехники',
      price: 600,
      unit: 'PIECE',
    },
    {
      id: 1264,
      name: 'Монтаж тёплого пола (электрического)',
      price: 500,
      unit: 'METER_SQUARED',
    },
    {
      id: 763,
      name: 'Изоляция потолка (тепло / шумо / гидро)',
      price: 300,
      unit: 'METER_SQUARED',
    },
    {
      id: 624,
      name: 'Демонтаж электропроводки',
      price: 100,
      unit: 'METER',
    },
  ],
  capital: [
    {
      id: 122,
      name: 'Замена повреждённой трубы',
      price: 5100,
      unit: 'PIECE',
    },
    {id: 752, name: 'Перенос розетки', price: 2400, unit: 'PIECE'},
    {
      id: 1270,
      name: 'Возведение перегородки из кирпича',
      price: 1400,
      unit: 'METER_SQUARED',
    },
    {
      id: 855,
      name: 'Монтаж тёплого пола (водяного)',
      price: 600,
      unit: 'METER_SQUARED',
    },
    {
      id: 1264,
      name: 'Монтаж тёплого пола (электрического)',
      price: 500,
      unit: 'METER_SQUARED',
    },
  ],
  design: [],
};
